module.exports = __webpack_public_path__ + "static/media/kid2.416e1c87.png";